<ng-template #attente>
  <div class="car-page" style="justify-content: center; align-items: center; min-height: 50vh;">
    <div style="width: 200px;">
      <div class="car-progress-bar">
        <div class="car-progress-bar__inner"></div>
      </div>
      <p class="car-page__subtitle" style="text-align: center;">Chargement des données...</p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="enregistrementTerminer; else attente">
  <div class="car-page">

    <div class="car-page__header">
      <h1 class="car-page__title">
        <div class="car-page__title-icon">
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
          </svg>
        </div>
        Gestion des Bannières & Images
      </h1>
      <p class="car-page__subtitle">Configurez les images déroulantes et fixes du catalogue</p>
    </div>

    <div class="car-panel">
      <div class="car-panel__header">
        <div class="car-panel__header-left">
          <div class="car-panel__icon">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </div>
          Liste images déroulantes (950 x 400)
        </div>

        <div class="car-panel__header-actions car-toolbar">
          <input id="input_666_450" name="uploaderCarouselAdd" type="file" style="display: none"
            (change)="onChangeImagefile($event, 'ajouterBannier')" />
          <input id="input_modifier_666_450" name="uploaderCarouselEdit" type="file" style="display: none"
            (change)="onChangeImagefile($event, 'modifierBannier')" />

          <button class="car-btn car-btn--outline" [disabled]="isSaving" (click)="importer('666_450')" title="Ajouter">
            <span *ngIf="isSaving" class="car-spinner"></span>
            <svg *ngIf="!isSaving" width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
            </svg>
            Importer
          </button>

          <button class="car-btn car-btn--outline" [disabled]="isSaving" (click)="importer('modifier_666_450')"
            title="Modifier">
            <span *ngIf="isSaving" class="car-spinner"></span>
            Modifier
          </button>

          <button class="car-btn car-btn--outline" [disabled]="isSaving" (click)="ajouterArticle1()" title="Échanger">
            <span *ngIf="isSaving" class="car-spinner"></span>
            Échanger
          </button>

          <button class="car-btn car-btn--danger" [disabled]="isSaving" (click)="supprimer()">
            <span *ngIf="isSaving" class="car-spinner"></span>
            Supprimer
          </button>

          <button class="car-btn car-btn--success" [disabled]="isSaving" (click)="saveAllOrders()">
            <span *ngIf="isSaving" class="car-spinner"></span>
            Ordres
          </button>

          <button class="car-btn car-btn--primary" [disabled]="isSaving" (click)="enregistrerTextImage()">
            <span *ngIf="isSaving" class="car-spinner"></span>
            Sauvegarder
          </button>
        </div>
      </div>

      <div class="car-panel__body">
        <div class="grp-banner-grid">
          <div *ngFor="let img of listeImages; let i = index" class="grp-form-strip"
            style="flex-direction: column; align-items: stretch; padding: 12px;">

            <div class="grp-img-upload" (click)="selectImageDeatail(img.File_Id, i)">
              <div class="grp-img-upload__preview" style="width: 100%; height: 110px; border-radius: var(--radius-xs);">
                <img [id]="img.File_Id"
                  [src]="(useDataBaseToSaveImage == 1 ? img.File_Content : base_url + 'images/') + img.File_Content" />
                <div class="grp-img-upload__overlay">
                  <span>Sélectionner</span>
                </div>
              </div>
            </div>

            <div class="car-field">
              <label class="car-label">Texte Français</label>
              <input class="car-input" [name]="'carouselTextInputFr_' + img.File_Id" [(ngModel)]="img.File_Text"
                placeholder="Français" [disabled]="isSaving" (focus)="selectImageDeatail(img.File_Id, i)" />
            </div>

            <div class="car-field">
              <label class="car-label">Texte Anglais</label>
              <input class="car-input" [name]="'carouselTextInputEn_' + img.File_Id" [(ngModel)]="img.textAnglais"
                placeholder="Anglais" [disabled]="isSaving" (focus)="selectImageDeatail(img.File_Id, i)" />
            </div>

            <div class="car-field">
              <label class="car-label">Ordre d'affichage</label>
              <select class="car-input" [name]="'carouselOrderSelect_' + img.File_Id" [(ngModel)]="img.File_Ordre"
                [disabled]="isSaving">
                <option *ngFor="let _ of listeImages; let idx = index" [value]="idx + 1">{{ idx + 1 }}</option>
              </select>
            </div>

          </div>
        </div>

        <div class="car-table-wrap" style="margin-top: 10px;">
          <app-liste #listeComponen [showFilter]="false" [heightTable]="'400'" [displayedColumnsBrut]="columns"
            [listBtn]="listBtn" (btnTable)="clickBtnHeat($event)">
          </app-liste>
        </div>
      </div>
    </div>

    <div class="car-grid">

      <div class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">Image fixe (234 x 450)</div>
        </div>
        <div class="car-panel__body">
          <div class="car-grid" style="grid-template-columns: 1fr 1fr;">

            <div class="car-field">
              <label class="car-label">Position 1</label>
              <div class="grp-img-upload" (click)="importer('1_234_450')">
                <div class="grp-img-upload__preview" style="width: 100%; height: 180px;">
                  <img id="1_234_450"
                    [src]="(useDataBaseToSaveImage == 1 ? img_1_234_450.File_Content : base_url + 'images/') + img_1_234_450.File_Content" />
                  <div class="grp-img-upload__overlay"><span>Modifier</span></div>
                </div>
                <input id="input_1_234_450" name="uploaderFixedImageOne" type="file" style="display: none"
                  (change)="onChangeImagefile($event, 'enregistrerImageFixe1')" [disabled]="isSaving" />
              </div>
            </div>

            <div class="car-field">
              <label class="car-label">Position 2</label>
              <div class="grp-img-upload" (click)="importer('2_234_450')">
                <div class="grp-img-upload__preview" style="width: 100%; height: 180px;">
                  <img id="2_234_450"
                    [src]="(useDataBaseToSaveImage == 1 ? img_2_234_450.File_Content : base_url + 'images/') + img_2_234_450.File_Content" />
                  <div class="grp-img-upload__overlay"><span>Modifier</span></div>
                </div>
                <input id="input_2_234_450" name="uploaderFixedImageTwo" type="file" style="display: none"
                  (change)="onChangeImagefile($event, 'enregistrerImageFixe2')" [disabled]="isSaving" />
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="car-panel" *ngIf="generalService.cuurentUser == 'SNCT'">
        <div class="car-panel__header grp-banner-header">
          <div class="car-panel__header-left">
            <span class="grp-banner-accent"></span>
            Bannière (415 x 260)
          </div>
        </div>
        <div class="car-panel__body">
          <div class="car-grid" style="grid-template-columns: 1fr 1fr;">

            <div class="car-field">
              <label class="car-label">Bannière Primaire</label>
              <div class="grp-img-upload" (click)="importer('banniere2.1')">
                <div class="grp-img-upload__preview" style="width: 100%; height: 120px;">
                  <img id="banniere2.1"
                    [src]="(useDataBaseToSaveImage == 1 ? Banner1.File_Content : base_url + 'images/') + Banner1.File_Content" />
                  <div class="grp-img-upload__overlay"><span>Modifier</span></div>
                </div>
                <input id="input_banniere2.1" name="uploaderBannerOne" type="file" style="display: none"
                  (change)="onChangeImagefile($event, 'enregistrerBanner2.1')" [disabled]="isSaving" />
              </div>
            </div>

            <div class="car-field" style="gap: 10px;">
              <label class="car-label">Bannière Secondaire</label>
              <div class="grp-img-upload" (click)="importer('banniere2.2')">
                <div class="grp-img-upload__preview" style="width: 100%; height: 120px;">
                  <img id="banniere2.2"
                    [src]="(useDataBaseToSaveImage == 1 ? Banner2.File_Content : base_url + 'images/') + Banner2.File_Content" />
                  <div class="grp-img-upload__overlay"><span>Modifier</span></div>
                </div>
                <input id="input_banniere2.2" name="uploaderBannerTwo" type="file" style="display: none"
                  (change)="onChangeImagefile($event, 'enregistrerBanner2.2')" [disabled]="isSaving" />
              </div>

              <input class="car-input" name="bannerCategorieUrlInput" [(ngModel)]="Banner2.File_Lien"
                (focus)="onFocusInput()" (blur)="updateLienBanner2()" placeholder="URL de redirection..."
                [disabled]="isSaving" />
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</ng-container>